import React from 'react';
import './ExpHero.css';

const ExpHero = ({text}) => {
    return (
        <div className="expHero-root d-flex justify-content-center align-items-center">
            <h1 data-aos="fade-up" className="text-white">{text}</h1>
        </div>
    );
};

export default ExpHero;